import { useLayoutEffect } from "react";

type PageMetadataProps = { title: string; description?: string | null; image?: string | null; url: string };
const truncate = (value: string, max = 160) => value.length > max ? `${value.slice(0, max - 1).trimEnd()}…` : value;

function setMeta(attribute: "name" | "property", key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!tag) { tag = document.createElement("meta"); tag.setAttribute(attribute, key); document.head.appendChild(tag); }
  tag.content = content;
}

export default function PageMetadata({ title, description, image, url }: PageMetadataProps) {
  useLayoutEffect(() => {
    const fullTitle = `${title} | CityMoshi`;
    const summary = truncate(description?.replace(/\s+/g, " ").trim() || "Discover events and community moments on CityMoshi.");
    const absoluteUrl = new URL(url, window.location.origin).toString();
    const absoluteImage = image ? new URL(image, window.location.origin).toString() : undefined;
    document.title = fullTitle;
    setMeta("name", "description", summary); setMeta("property", "og:title", fullTitle); setMeta("property", "og:description", summary); setMeta("property", "og:url", absoluteUrl); setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", absoluteImage ? "summary_large_image" : "summary"); setMeta("name", "twitter:title", fullTitle); setMeta("name", "twitter:description", summary);
    if (absoluteImage) { setMeta("property", "og:image", absoluteImage); setMeta("name", "twitter:image", absoluteImage); }
    else {
      document.head.querySelector('meta[property="og:image"]')?.remove();
      document.head.querySelector('meta[name="twitter:image"]')?.remove();
    }
  }, [title, description, image, url]);
  return null;
}
